import { ref } from 'vue'

export const dashboardArianeBus = ref({ active: false, link: '', name: '' })
